import React from "react";

/* Ícones de traço (stroke) usados na navegação — herdam currentColor.
   Traço fino e uniforme para combinar com a estética de papel do sistema. */

const base = {
    width: 20, height: 20, viewBox: "0 0 24 24", fill: "none",
    stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round"
};

export const IconeInicio = (p) => (
    <svg {...base} {...p}><path d="M3 10.5 12 3l9 7.5" /><path d="M5 9.5V21h14V9.5" /><path d="M9 21v-6h6v6" /></svg>
);
export const IconeAgenda = (p) => (
    <svg {...base} {...p}><rect x="3" y="4.5" width="18" height="16" rx="2" /><path d="M3 9h18M8 3v4M16 3v4" /></svg>
);
export const IconeContratos = (p) => (
    <svg {...base} {...p}><path d="M6 2h8l4 4v16H6z" /><path d="M14 2v4h4M9 12h6M9 16h6" /></svg>
);
export const IconeProcessos = (p) => (
    <svg {...base} {...p}><path d="M12 3v18M5 7h14" /><path d="M5 7 3 13a3 3 0 0 0 4 0zM19 7l-2 6a3 3 0 0 0 4 0z" /></svg>
);
export const IconePrazos = (p) => (
    <svg {...base} {...p}><circle cx="12" cy="13" r="8" /><path d="M12 9v4l2.5 2.5M9 2h6" /></svg>
);
export const IconePagamentos = (p) => (
    <svg {...base} {...p}><rect x="2.5" y="6" width="19" height="12" rx="2" /><path d="M2.5 10h19M6 14h3" /></svg>
);
export const IconeClientes = (p) => (
    <svg {...base} {...p}><circle cx="12" cy="8" r="3.5" /><path d="M5 20a7 7 0 0 1 14 0" /></svg>
);
export const IconeBusca = (p) => (
    <svg {...base} {...p}><circle cx="11" cy="11" r="7" /><path d="m20 20-3.2-3.2" /></svg>
);
export const IconeMais = (p) => (
    <svg {...base} {...p}><circle cx="5" cy="12" r="1.6" /><circle cx="12" cy="12" r="1.6" /><circle cx="19" cy="12" r="1.6" /></svg>
);
